import api from '../../services/api';

export interface ImponibleData {
  cuit: string;
  tipo: string;
  id: number;
  created_at: Date;
  updated_at: Date | null;
  referencia: string;
  imponible: string;
  informacion: { [key: string]: null | string };
  recursos: Recurso[];
  color: string;
  apremio: boolean;
  debito: boolean;
}

export interface Recurso {
  recurso: string;
  descripcion: string;
  descr_abrev: string;
  anual: null | string;
  color: string;
  planes: string;
  semestral: null | boolean;
}

async function getImponiblesByCuit() {
  const response = await api<ImponibleData[]>(
    'GET',
    'suscripciones/imponibles'
  );

  return response;
}

export interface CreatedImponible {
  cuit: string;
  tipo: string;
  id: number;
  referencia: string;
  updated_at: Date;
  created_at: Date;
  debito: boolean
}

export interface ImponiblePayload {
  tipo: string;
  id: string;
  ref: string;
}

async function createImponible(payload: ImponiblePayload) {
  const response = await api<ImponibleData>('POST', 'suscripciones', payload);

  return response;
}

async function getImponible(id: number) {
  const response = await api<ImponibleData>('GET', `suscripciones/${id}`);

  return response;
}

async function unlinkImponible(id: number) {
  const response = await api<ImponibleData>('DELETE', `suscripciones/${id}`);

  return response;
}

const imponiblesAPI = {
  getImponiblesByCuit,
  createImponible,
  getImponible,
  unlinkImponible,
};

export default imponiblesAPI;
